module.exports = __webpack_public_path__ + "assets/sudaqishui.c6b40867.svg";